import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import "../../styles/css/ElevationForm/elevationForm.css";

import "filepond/dist/filepond.min.css";
import { FilePond, File, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginFileEncode
);

class SectionH extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPanel1: false,
      showPanel2: false,
      showPanel3: false,
      showPanel4: false,
    };
  }
  imageUploadOpen1 = () => {
    this.setState({
      showPanel1: true,
    });
  };
  imageUploadOpen2 = () => {
    this.setState({
      showPanel2: true,
    });
  };

  imageUploadOpen3 = () => {
    this.setState({
      showPanel3: true,
    });
  };
  imageUploadOpen4 = () => {
    this.setState({
      showPanel4: true,
    });
  };
  render() {
    const { showPanel1, showPanel2, showPanel3, showPanel4 } = this.state;
    const { sectionH, onClickH, validateH } = this.props;
    return (
      <div className="form-wrapper-elevation">
        <div>
          <h2>BUILDING PHOTOGRAPHS</h2>
          {sectionH.isSubmittedH === false ? (
            <div className="err-msg-content">
              Something went wrong. Please try again.
            </div>
          ) : null}

          <p>
            If using the Elevation Certificate to obtain NFIP flood insurance,
            affix at least 2 building photographs below according to the
            instructions for Item A6. Identify all photographs with date taken;
            "Front View" and "Rear View"; and, if required, "Right Side View"
            and "Left Side View." When applicable, photographs must show the
            foundation with representative examples of the flood openings or
            vents, as indicated in Section A8. If submitting more photographs
            than will fit on this page, use the Continuation Page.
          </p>
          <div className="image-content-wrapper">
            <div
              className="btn-wrapper"
              style={showPanel1 ? { display: "none" } : { display: "block" }}
            >
              <button className="upload-btn" onClick={this.imageUploadOpen1}>
                Upload a Front View Photograph
              </button>
            </div>
            {this.state.showPanel1 === true ? (
              <div className="image-upload-panel">
                <h6>1) Upload a Front View Photograph</h6>
                <div className="photo-details">
                  <div className="left-container">
                    Photo One Caption
                    <input
                      name="front_view_caption"
                      value={sectionH.front_view_caption}
                      onChange={onClickH}
                      type="text"
                      className="caption"
                    />
                    {validateH.message(
                      "caption",
                      sectionH.front_view_caption,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                  <div className="right-container">
                    {" "}
                    Date
                    <input
                      name="front_view_date"
                      value={sectionH.front_view_date}
                      onChange={onClickH}
                      type="date"
                      className="caption"
                    />
                    {validateH.message(
                      "date",
                      sectionH.front_view_date,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                </div>
                <FilePond
                  allowFileEncode={true}
                  // acceptedFileTypes={["image/png", "image/jpeg"]}
                  imagePreviewMaxHeight="256"
                  ref={(ref) => (this.pond = ref)}
                  files={sectionH.front_view_img}
                  allowMultiple={true}
                  maxFiles={1}
                  name="files"
                  labelIdle="Click here or drop your files here"
                  onupdatefiles={(fileItems) => {
                    this.props.frontView(fileItems);
                  }}
                ></FilePond>
                {validateH.message("image", sectionH.front_view_img, "", {
                  className: "error-msg-text",
                })}
              </div>
            ) : null}

            <div
              className="btn-wrapper"
              style={showPanel2 ? { display: "none" } : { display: "block" }}
            >
              <button className="upload-btn" onClick={this.imageUploadOpen2}>
                Upload a Rear View Photograph
              </button>
            </div>
            {this.state.showPanel2 === true ? (
              <div className="image-upload-panel">
                <h6>2) Upload a Rear View Photograph</h6>
                <div className="photo-details">
                  <div className="left-container">
                    Photo Two Caption
                    <input
                      name="rear_view_caption"
                      value={sectionH.rear_view_caption}
                      onChange={onClickH}
                      type="text"
                      className="caption"
                    />
                    {validateH.message(
                      "caption",
                      sectionH.rear_view_caption,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                  <div className="right-container">
                    {" "}
                    Date
                    <input
                      name="rear_view_date"
                      value={sectionH.rear_view_date}
                      onChange={onClickH}
                      type="date"
                      className="caption"
                    />
                    {validateH.message(
                      "date",
                      sectionH.rear_view_date,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                </div>
                <FilePond
                  allowFileEncode={true}
                  // acceptedFileTypes={["image/png", "image/jpeg"]}
                  imagePreviewMaxHeight="256"
                  ref={(ref) => (this.pond = ref)}
                  files={sectionH.rear_view_img}
                  allowMultiple={true}
                  maxFiles={1}
                  name="files"
                  labelIdle="Click here or drop your files here"
                  onupdatefiles={(fileItems) => {
                    this.props.rearView(fileItems);
                  }}
                ></FilePond>
                {validateH.message("image", sectionH.rear_view_img, "", {
                  className: "error-msg-text",
                })}
              </div>
            ) : null}

            <div
              className="btn-wrapper"
              style={showPanel3 ? { display: "none" } : { display: "block" }}
            >
              <button className="upload-btn" onClick={this.imageUploadOpen3}>
                Upload a Right View Photograph
              </button>
            </div>
            {this.state.showPanel3 === true ? (
              <div className="image-upload-panel">
                <h6>3) Upload a Right View Photograph</h6>
                <div className="photo-details">
                  <div className="left-container">
                    Photo Three Caption
                    <input
                      name="right_view_caption"
                      value={sectionH.right_view_caption}
                      onChange={onClickH}
                      type="text"
                      className="caption"
                    />
                    {validateH.message(
                      "caption",
                      sectionH.right_view_caption,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                  <div className="right-container">
                    {" "}
                    Date
                    <input
                      name="right_view_date"
                      value={sectionH.right_view_date}
                      onChange={onClickH}
                      type="date"
                      className="caption"
                    />
                    {validateH.message(
                      "date",
                      sectionH.right_view_date,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                </div>
                <FilePond
                  allowFileEncode={true}
                  // acceptedFileTypes={["image/png", "image/jpeg"]}
                  imagePreviewMaxHeight="256"
                  ref={(ref) => (this.pond = ref)}
                  files={sectionH.right_view_img}
                  allowMultiple={true}
                  maxFiles={1}
                  name="files"
                  labelIdle="Click here or drop your files here"
                  onupdatefiles={(fileItems) => {
                    this.props.rightView(fileItems);
                  }}
                ></FilePond>
                {validateH.message("image", sectionH.right_view_img, "", {
                  className: "error-msg-text",
                })}
              </div>
            ) : null}
            <div
              className="btn-wrapper"
              style={showPanel4 ? { display: "none" } : { display: "block" }}
            >
              <button className="upload-btn" onClick={this.imageUploadOpen4}>
                Upload a Left View Photograph
              </button>
            </div>
            {this.state.showPanel4 === true ? (
              <div className="image-upload-panel">
                <h6>4) Upload a Left View Photograph</h6>
                <div className="photo-details">
                  <div className="left-container">
                    Photo Four Caption
                    <input
                      name="left_view_caption"
                      value={sectionH.left_view_caption}
                      onChange={onClickH}
                      type="text"
                      className="caption"
                    />
                    {validateH.message(
                      "caption",
                      sectionH.left_view_caption,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                  <div className="right-container">
                    {" "}
                    Date
                    <input
                      name="left_view_date"
                      value={sectionH.left_view_date}
                      onChange={onClickH}
                      type="date"
                      className="caption"
                    />
                    {validateH.message(
                      "date",
                      sectionH.left_view_date,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                </div>
                <FilePond
                  allowFileEncode={true}
                  // acceptedFileTypes={["image/png", "image/jpeg"]}
                  imagePreviewMaxHeight="256"
                  ref={(ref) => (this.pond = ref)}
                  files={sectionH.left_view_img}
                  allowMultiple={true}
                  maxFiles={1}
                  name="leftView"
                  labelIdle="Click here or drop your files here"
                  onupdatefiles={(fileItems) => {
                    this.props.leftView(fileItems);
                  }}
                ></FilePond>
                {validateH.message("image", sectionH.left_view_img, "", {
                  className: "error-msg-text",
                })}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default SectionH;



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/SectionH.js